import { useState, createContext, useContext, useEffect, useCallback } from "react";
import axios from "axios";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { Notification, Placeholder, toaster } from "rsuite";
import { ReactSession } from 'react-client-session';

const StoreContext = createContext(null);
export const DataProvider = ({ children }) => {
  const [teamManagerData, setTeamManagerData] = useState([]);
  // const [initStoreDateRange, setInitStoreDateRange] = useState([
  //   (new Date()),
  //   (new Date()),
  // ]);
 const [initStoreDateRange, setInitStoreDateRange] = useState([
    (new Date()),
    (new Date()),
  ]);
  
  const currentUser = JSON.parse(localStorage.getItem("__react_session__"));
  const [storeSelectedPlanType, setStoreSelectedPlantype] = useState("manager");
  const [storeSelectedReportBy, setStoreSelectedReportBy] = useState("day");
  const [storeSelectedHoursDollarsRadio, setStoreSelectedHoursDollarsRadio] =
    useState("dollars");
  const [storeStartEndRadio, setStoreStartEndRadio] = useState("end");
  const [storeMajorMeasureGroups, setStoreMajorMeasureGroups] = useState([]);
  const [storeMasterTaskGroups, setStoreMasterTaskGroups] = useState([]);
  const [storeSelectedCheckerPickerValue, setStoreSelectedCheckerPickerValue] =
    useState([]);
  const [closedColumnList, setClosedColumnList] = useState([]);
  const [resetFilter, SetResetFilter] = useState(false);
  const [managerScreenLoading, setManagerScreenLoading] = useState(false);
  const [timesheetData, setTimesheetData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [sortValue, setSortValue] = useState("");
  const [showColumn, setShowColumn] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [loading, setLoading] = useState(true);
  const [siteLocation, setSiteLocation] = useState(window.location.pathname);
  const [storeSelectedDetailSummaryView, setStoreSelectedDetailSummaryView] =
    useState("summary");
  const [majorTasks, setMajorTasks] = useState([]);
  const [majorMeasure, setMajorMeasure] = useState([]);
  const [processData, setProcessData] = useState([]);
  const [teams, setTeams] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamManager, setTeamManager] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [tasksDesc, setTasksDes] = useState([]);
  const [tasksgroup, setTasksGroup] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [selectedTeamManager, setSelectedTeamManager] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedMajorTasks, setSelectedMajorTasks] = useState([]);
  const [selectedMajorMeasure, setSelectedMajorMeasure] = useState([]);
  const [selectedProcessData, setSelectedProcessData] = useState([]);
  const [selectedTasksDesc, setSelectedTasksDes] = useState([]);
  const [selectedTasksgroup, setSelectedTasksGroup] = useState([]);
  const [selectedSubTasks, setSelectedsubTasks] = useState([]);
  const [selectedSubSubTasks, setSelectedSubSubTask] = useState([]);
  const [SelectedPredecessor, setSelectedPredecessor] = useState([]);
  const [Selectedsuccessor, setSelectedsuccessor] = useState([]);
  const [SelectTypeOfProlem, setSelectTypeOfProlem] = useState([]);
  const [filterConditions, setFilterConditions] = useState([]);
  const [managers, setManagers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [subtaskDescrption, setSubtaskDescrption] = useState([]);
  const [subSubtaskDescrption, setSubSubtaskDescrption] = useState([]);
  const [storeProjects, setStoreProjects] = useState([]);
  const selectedFilterValues = [];
  const [selectedProjectsData, setSelectedProjectData] = useState([]);
  const [storeTeamMgrGrandTotalRow, setStoreTeamMgrGrandTotalRow] = useState(
    []
  );
  const [storeTimesheetGrandTotalRow, setStoreTimesheetGrandTotalRow] =
    useState([]);
  const [refresh, setRefresh] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);
  const [DuplicateContaineTeamManger, setDuplicateContaineTeamManger] = useState([])
  const [listCustomReport, setListCustomReport] = useState([]);
  const[reportlabel,setreportlabel] =useState('')
  const [ spName, setspdetail ] =useState('')
  const [totalTeamMangerScreen, setTotalTeamMangerScreen] = useState([]);
  const [totalTimesheetScreen, setTotalTimesheetScreen] = useState([]);
  const [ProductTimelines24Months, setProductTimelines24Months] = useState([]);
  const [weeklydata, setweeklydata] = useState('');
  const [getProjectMangerList, setProjectMangerList] = useState([]);
  const [selectedCountry, setselectedCountry] = useState([]);
  const [ControllermajorTasks, ControllermsetMajorTasks] = useState([]);
  const [ControllermmajorMeasure, ControllermsetMajorMeasure] = useState([]);
  const [country, setCountry] = useState([
		{ label: "India", value :"India" ,id: 1 , },
		{ label: "US", value :"US" ,id: 2 },
	  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLimit, setCurrentLimit] = useState(50);

    

  const [placement, setPlacement] = useState("topCenter");
  const [rowCount, setRowCount] = useState();
  const ErrorMessage = (
    <Notification
      type={"error"}
      header={""}
      style={{ background: "#ff8400", color: "#ffff", padding: "0" }}
      closable
    >
      There is no data in the Controller's Budget for this column
    </Notification>
  );


  const CintrollergetMajorMeasure = async () => {
    try {
      const response = await axios.get("/api/v1/crud/major-measuresController");
      let MajorMeasureDataFromAPI = response.data.message
        .map(
          (desc) =>
            desc.major_measure_name && {
              label: desc.major_measure_name,
              value: desc.major_measure_name,
              id: parseInt(desc.base_sk_major_measure),
            }
        )
      .filter(Boolean);
      ControllermsetMajorMeasure(MajorMeasureDataFromAPI);
      console.log("MajorMeasureDataFromAPI",MajorMeasureDataFromAPI);

    


    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  
  //************  get  DATA ***************/
  const ControllergetMajorTasks = async () => {
    try {
      const response = await axios.get("/api/v1/crud/major-tasksController");
      let MajorTaskDataFromAPI = response.data.message
        .map(
          (desc) =>
            desc.major_task_name && {
              label: desc.major_task_name,
              value: desc.major_task_name,
              mmid: desc.irk_major_measure,
              id: parseInt(desc.base_sk_major_task),
            }
        )
        .filter(Boolean);

      
        ControllermsetMajorTasks(MajorTaskDataFromAPI);
    } catch (error) {
      console.error("Error While Fetching Major Tasks From API - ", error);
    }
  };


  //************  get  DATA ***************/
  const getMajorTasks = async () => {
    try {
      const response = await axios.get("/api/v1/crud/major-tasks");
      let MajorTaskDataFromAPI = response.data.message
        .map(
          (desc) =>
            desc.major_task_name && {
              label: desc.major_task_name,
              value: desc.major_task_name,
              mmid: desc.irk_major_measure,
              id: parseInt(desc.base_sk_major_task),
            }
        )
        .filter(Boolean);

      const uniqueData = [];
      const uniqueLabels = new Set();
      MajorTaskDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label)) {
          uniqueLabels.add(MT.label);
          uniqueData.push(MT);
        }
      });
      setMajorTasks(uniqueData);
    } catch (error) {
      console.error("Error While Fetching Major Tasks From API - ", error);
    }
  };

  const getMajorMeasureGroups = async () => {
    try {
      const response = await axios.get("/api/v1/crud/major-measure-groups");
      let MMGroupDataFromAPI = response.data.message
        .map((obj) => ({
          label: obj.mm_group_desc,
          value: obj.mm_group_desc,
          id: parseInt(obj.base_sk_mm_group),
        }))
        .filter(Boolean);
      const uniqueData = [];
      const uniqueLabels = new Set();
      MMGroupDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label)) {
          uniqueLabels.add(MT.label);
          uniqueData.push(MT);
        }
      });

      setStoreMajorMeasureGroups(MMGroupDataFromAPI);
      // console.log('MM Group API RESP - ', response.data.message);
    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  const getProjectEntry = async () => {
    try {
      const response = await axios.get("/api/v1/crud/projects");
      let MMPEroupDataFromAPI = response.data.message
        .map((obj) => ({
          label: obj.project_desc,
          value: obj.project_desc,
          id: parseInt(obj.base_sk_mst_projects),
        }))
        .filter(Boolean);
      const uniqueData = [];
      const uniqueLabels = new Set();
      MMPEroupDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label)) {
          uniqueLabels.add(MT.label);
          uniqueData.push(MT);
        }
      });
      setStoreProjects(uniqueData);
      //console.log("projects  API RESP - ", response.data.message);
    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  const getMajorMeasure = async () => {
    try {
      const response = await axios.get("/api/v1/crud/major-measures");
      let MajorMeasureDataFromAPI = response.data.message
        .map(
          (desc) =>
            desc.major_measure_name && {
              label: desc.major_measure_name,
              value: desc.major_measure_name,
              id: parseInt(desc.base_sk_major_measure),
            }
        )
        .filter(Boolean);
      const uniqueData = [];
      const uniqueLabels = new Set();
      MajorMeasureDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label)) {
          uniqueLabels.add(MT.label);
          uniqueData.push(MT);
        }
      });
      setMajorMeasure(uniqueData);
      //console.log(response.data);
    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  const getProcess = async () => {
    try {
      const response = await axios.get("/api/v1/crud/processes");
      const processDataFromAPI = response.data.message.map((process) => ({
        label: process.process_name,
        value: process.process_name,
        id: process.base_sk_process,
      }));

      const uniqueData = [];
      const uniqueLabels = new Set();
      processDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label)) {
          uniqueLabels.add(MT.label);
          uniqueData.push(MT);
        }
      });

      setProcessData(uniqueData);
      //console.log("uniqueData::::::::;;::", uniqueData);
    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  const getTeams = async () => {
    try {
      const response = await axios.get("/api/v1/crud/teams");
      let TeamsDataFromAPI = response.data.message
        .map(
          (desc) =>
            desc.team_name && {
              label: desc.team_name,
              value: desc.team_name,
              // id: desc.sk_team,
              skid: desc.sk_team_member,
              id: parseInt(desc.base_sk_team),
              avgDlrs: desc.avg_loaded_dollars,
            }
        )
        .filter(Boolean);
      const uniqueData = [];
      const uniqueLabels = new Set();
      TeamsDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label)) {
          uniqueLabels.add(MT.label);
          uniqueData.push(MT);
        }
      });
      //console.log("  TeamsDataFromAPI --- ", uniqueData);
      setTeams(uniqueData);

      ///console.log('Prepared Teams Data --- ', TeamsDataFromAPI);
      setTeams(TeamsDataFromAPI);
      let TeamsManagerDataFromAPI = response.data.message
        .map(
          (desc) =>
            desc.team_name && {
              label: desc.team_manager_name,
              value: desc.team_manager_name,
              id: parseInt(desc.irk_team_mgr_id),
            }
        )
        .filter(Boolean);
      const uniqueData1 = [];
      const uniqueLabels1 = new Set();
      TeamsManagerDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels1.has(MT.label)) {
          uniqueLabels1.add(MT.label);
          uniqueData1.push(MT);
        }
      });
      setTeamManager(uniqueData1);
      //console.log("-----------------------", response.data);
    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  const getTeamMember = async () => {
    try {
      const response = await axios.get("/api/v1/crud/team-members");
      console.log("TEAM MEMBERS ===== ", response.data);
      let TeamsMemberFromAPI = response?.data?.message
        ?.map((desc) => ({
          label: desc.team_member_name,
          value: desc.team_member_name,
          id: parseInt(desc.base_sk_team_member),
          team: desc.teams_participating_in?.map((x) => parseInt(x)) || [],
        }))
        .filter(Boolean);

      const uniqueData1 = [];
      const uniqueLabels1 = new Set();
      TeamsMemberFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels1.has(MT.label)) {
          uniqueLabels1.add(MT.label);
          uniqueData1.push(MT);
        }
      });
      ///console.log("Team member ::", uniqueData1);
      setTeamMembers(uniqueData1);
      setManagers(
        response?.data?.message
          ?.filter((x) => x.is_manager === true)
          .map((x) => ({
            label: x.team_member_name,
            value: x.team_member_name,
            id: x.sk_team_member,
          }))
      );
      setAdmins(
        response?.data?.message
          ?.filter((x) => x.is_admin === true)
          .map((x) => ({
            label: x.team_member_name,
            value: x.team_member_name,
            id: x.sk_team_member,
          }))
      );
      setApprovers(
        response?.data?.message
          ?.filter((x) => x.is_approver === true)
          .map((x) => ({
            label: x.team_member_name,
            value: x.team_member_name,
            id: x.sk_team_member,
          }))
      );
      // console.log('/api/v1/crud/team-members === ', TeamsMemberFromAPI);
    } catch (error) {
      console.error("Error While Fetching Team Members From API - ", error);
    }
  };

  const getTasks = async () => {
    try {
      const response = await axios.get("/api/v1/crud/tasks");
      let TasksFromAPI = response.data.message
        .map(
          (desc) =>
            desc.task_name && {
              label: desc.task_name,
              value: desc.task_name,
              id: desc.base_sk_task,
            }
        )
        .filter(Boolean);
      // setTasksDes(filteredData);
      const uniqueData1 = [];
      const uniqueLabels1 = new Set();
      TasksFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels1.has(MT.label)) {
          uniqueLabels1.add(MT.label);
          uniqueData1.push(MT);
        }
      });
      setTasks(uniqueData1);

      // setTasks(TasksFromAPI);
      let TasksFromAPIDes = response.data.message
        .map(
          (desc) =>
            desc.task_name && {
              label: desc.task_description,
              value: desc.task_description,
            }
        )
        .filter(Boolean);
      const uniqueData = [];
      const uniqueLabels = new Set();
      TasksFromAPIDes.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label.trim())) {
          uniqueLabels.add(MT.label.trim());
          uniqueData.push(MT);
        }
      });
      setTasksDes(uniqueData);
    } catch (error) {
      console.error("Error While Fetching Major Measures From API - ", error);
    }
  };

  const getTaskGroups = async () => {
    const response = await axios.get("/api/v1/crud/task-groups");
    let TasksFromAPIgroup = response.data.message.map((desc) => ({
      label: desc.task_group_desc,
      value: desc.task_group_desc,
      id: desc.sk_task_group,
    }));
    setStoreMasterTaskGroups(response.data.message);
    const uniqueData = [];
    const uniqueLabels = new Set();
    TasksFromAPIgroup.forEach((MT) => {
      if (MT.label !== null && !uniqueLabels.has(MT.label)) {
        uniqueLabels.add(MT.label);
        uniqueData.push(MT);
      }
    });
    setTasksGroup(uniqueData);
  };

  const getSubtask = async () => {
    try {
      const response = await axios.get("/api/v1/crud/subtasks");
      // console.log('/api/v1/crud/subtasks API RESP === ', response.data.message);
      let SubtaskDataFromAPI = response.data.message.map((desc) => ({
        label: desc.subtask_desc,
        value: desc.subtask_desc,
        id: desc.base_sk_subtask,
      }));
      const uniqueData = [];
      const uniqueLabels = new Set();
      SubtaskDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label.trim())) {
          uniqueLabels.add(MT.label.trim());
          uniqueData.push(MT);
        }
      });
      setSubtaskDescrption(uniqueData);
      //console.log("Processed Subtask Data:");
      uniqueData.forEach((subtask) => {
        // console.log("id:", subtask.id, "value:", subtask.value, "label:", subtask.label);
      });
    } catch (error) {
      console.error("Error fetching subtasks:", error);
    }
  };

  const getSubSubtask = async () => {
    try {
      const response = await axios.get("/api/v1/crud/sub-subtasks");
      // console.log('/api/v1/crud/sub-subtasks API RESP ==setSubSubtaskDescrption= ', response.data.message);
      let SubSubtaskDataFromAPI = response.data.message?.map((desc) => ({
        label: desc.sub_subtask_desc,
        value: desc.sub_subtask_desc,
      }));
      const uniqueData = [];
      const uniqueLabels = new Set();
      SubSubtaskDataFromAPI.forEach((MT) => {
        if (MT.label !== null && !uniqueLabels.has(MT.label.trim())) {
          uniqueLabels.add(MT.label.trim());
          uniqueData.push(MT);
        }
      });
      setSubSubtaskDescrption(uniqueData);
    } catch (error) {
      console.error("Error fetching Sub subtasks:", error);
    }
  };
  const getRoleList = async () => {
    axios
      .get("/api/v1/crud/roles")
      .then((resp) => {
        let r = resp.data.message.map((o) => ({
          value: o.base_sk_role,
          label: o.role_name,
        }));
        setRolesList(r);
      })
      .catch((err) =>
        console.error(`Error While Fetching Rolesd List - `, err)
      );
  }
  const getTeamList = async () => {
    axios
      .get("/api/v1/crud/teams")
      .then((resp) => {
        let filterableTeams = resp.data.message
          .map(
            (item) =>
              item.team_name && {
                label: item.team_name,
                value: item.sk_team,
              }
          )
          .filter(Boolean);
        setTeamsList(filterableTeams);
        setLoading(false);
      })
      .catch((error) =>
        console.error(`Error While Fetching Team List From API - `, error)
      );
  }

  
  const getCustomeReportList = async () => {
    await axios
    .request({
      baseURL: `/api/v1/user/custom-report`,
      params: {
        userid: JSON.parse(localStorage.getItem("__react_session__"))?.user?.userid,
      },
    })
    .then((resp) => {
      let filterCustomReport = resp.data.message
      .map(
        (item) =>
          item.report_name && {
            label: item.report_name,
            value: item.report_id,
          }
      )
      .filter(Boolean);
      setListCustomReport(filterCustomReport)
    })
};



const getProjectMangerPlanList = async () => {
  axios
  .get("/api/v1/projectMgr/getdetails-mgr")
  .then((resp) => {
    let filterableTeams = resp.data.message
    .map(
      (item) =>
        item.task && {
          task: item.task,
          description: item.task_description,
          irk_teams : item.irk_teams,
          irk_task :item.base_sk_mst_project_manager,
          irk_major_task:item.irk_major_task,
        }
    )
    .filter(Boolean);
      setProjectMangerList(filterableTeams);
   
  })
  .catch((error) =>
    console.error(`Error While Fetching Team List From API - `, error)
  );

};

  /*
  useEffect(() => {
    if (!managerScreenLoading) {
      selectedFilterValues.length = 0;
      setStoreSelectedCheckerPickerValue([]);
      setFilterConditions([]);
    }
    if (currentUser?.user?.userid) {
      getSubSubtask();
      getSubtask();
      getMajorTasks();
      getMajorMeasureGroups();
      getMajorMeasure();
      getProjectEntry();
      getProcess();
      getTeams();
      getTeamMember();
      getTasks();
      getTaskGroups();
      //fetchMasterTaskGroups();
      getTeamList();
      getRoleList();
      getCustomerReportList();
    }
  }, []);

  useEffect(() => {
    if (currentUser?.user?.userid) {
      getSubSubtask();
      getSubtask();
      getMajorTasks();
      getMajorMeasureGroups();
      getMajorMeasure();
      getProjectEntry();
      getProcess();
      getTeams();
      getTeamMember();
      getTasks();
      getTaskGroups();
      getTeamList();
      getRoleList();
      setRefresh(false);
    }
  }, [refresh])
  */
  useEffect(() => {
    if (!managerScreenLoading) {
      selectedFilterValues.length = 0;
      setStoreSelectedCheckerPickerValue([]);
      setFilterConditions([]);
    }

    if (currentUser?.user?.userid || refresh) {
      getSubSubtask();
      getSubtask();
      getMajorTasks();
      getMajorMeasureGroups();
      getMajorMeasure();
      getProjectEntry();
      getProcess();
      getTeams();
      getTeamMember();
      getTasks();
      getTaskGroups();
      getTeamList();
      getRoleList();
      getCustomeReportList();
     // getProjectMangerPlanList();
     CintrollergetMajorMeasure();
     ControllergetMajorTasks();
    }
  }, [currentUser?.user?.userid, refresh]);


  // const handleTeamPicker = (value) => {
  //   setSelectedTeams(value);
  //   // SetResetFilter(false);
  // };
  const handleTeamPicker = useCallback((value) => {
    setSelectedTeams(value);
  }, [setSelectedTeams]);

  // const handleTeamManagerPicker = (value) => {
  //   setSelectedTeamManager(value);
  //   // SetResetFilter(false);
  // };

  const handleTeamManagerPicker = useCallback((value) => {
    setSelectedTeamManager(value);
  }, [setSelectedTeamManager])

  // const handleTeamMemberPicker = (value) => {
  //   setSelectedTeamMembers(value);
  //   // SetResetFilter(false);
  // };

  const handleTeamMemberPicker = useCallback((value) => {
    setSelectedTeamMembers(value);
  }, [setSelectedTeamMembers])

  // const handleProcessPicker = (value) => {
  //   setSelectedProcessData(value);
  //   // SetResetFilter(false);
  // };
  const handleProcessPicker = useCallback((value) => {
    setSelectedProcessData(value);
  }, [setSelectedProcessData]);

  // const handleMajorMeasurePicker = (value) => {
  //   setSelectedMajorMeasure(value);
  //   // SetResetFilter(false);
  // };

  const handleMajorMeasurePicker = useCallback((value) => {
    setSelectedMajorMeasure(value);
  }, [setSelectedMajorMeasure]);

  // const handleMajorTaskPicker = (value) => {
  //   setSelectedMajorTasks(value);
  //   // SetResetFilter(false);
  // };

  const handleMajorTaskPicker = useCallback((value) => {
    setSelectedMajorTasks(value);
  }, [setSelectedMajorTasks]);

  // const handleTaskPicker = (value) => {
  //   setSelectedTasks(value);
  //   // SetResetFilter(false);
  // };
  const handleTaskPicker = useCallback((value) => {
    setSelectedTasks(value);
  }, [setSelectedTasks]);

  // const handleTaskDescPicker = (value) => {
  //   setSelectedTasksDes(value);
  //   // SetResetFilter(false);
  // };

  const handleTaskDescPicker = useCallback((value) => {
    setSelectedTasksDes(value);
  }, [setSelectedTasksDes]);

  // const handleSubTaskPicker = (value) => {
  //   setSelectedsubTasks(value);
  //   // SetResetFilter(false);
  // };
  const handleSubTaskPicker = useCallback((value) => {
    setSelectedsubTasks(value);
  }, [setSelectedsubTasks]);

  // const handleSubSUbTaskPicker = (value) => {
  //   setSelectedSubSubTask(value);
  //   console.log("handleSubSUbTaskPicker ::", value);
  //   // SetResetFilter(false);
  // };
  const handleSubSUbTaskPicker = useCallback((value) => {
    setSelectedSubSubTask(value);
  }, [setSelectedSubSubTask]);

  // const handleTaskGroupPicker = (value) => {
  //   setSelectedTasksGroup(value);
  //   // SetResetFilter(false);
  // };
  const handleTaskGroupPicker = useCallback((value) => {
    setSelectedTasksGroup(value);
  }, [setSelectedTasksGroup]);

  // const handlePredecessorPicker = (value) => {
  //   setSelectedPredecessor(value);
  //   // SetResetFilter(false);
  // };
  const handlePredecessorPicker = useCallback((value) => {
    setSelectedPredecessor(value);
  }, [setSelectedPredecessor]);

  // const handlSuccessorPicker = (value) => {
  //   setSelectedsuccessor(value);
  //   // SetResetFilter(false);
  // };

  const handlSuccessorPicker = useCallback((value) => {
    setSelectedsuccessor(value);
    // SetResetFilter(false);
  }, [setSelectedsuccessor]);

  // const handleTypeOfProblemPicker = (value) => {
  //   setSelectTypeOfProlem(value);
  //   // SetResetFilter(false);
  // };
  const handleTypeOfProblemPicker = useCallback((value) => {
    setSelectTypeOfProlem(value);
  }, [setSelectTypeOfProlem]);

  // const handleStoreHoursDollarsRadioChange = (value) => {
  //   setStoreSelectedHoursDollarsRadio(value);
  // };
  const handleStoreHoursDollarsRadioChange = useCallback((value) => {
    setStoreSelectedHoursDollarsRadio(value);
  }, [setStoreSelectedHoursDollarsRadio]);

  // const handleStoreSummaryDetailRadioView = (value) => {
  //   setStoreSelectedDetailSummaryView(value);
  // };

  const handleStoreSummaryDetailRadioView = useCallback((value) => {
    setStoreSelectedDetailSummaryView(value);
  }, [setStoreSelectedDetailSummaryView]);

  // const handleStoreStartEndRadioChange = (value) => {
  //   // console.log(`setStoreStartEnd VALUE === `, value);
  //   setStoreStartEndRadio(value);
  // };

  const handleStoreStartEndRadioChange = useCallback((value) => {
    // console.log(`setStoreStartEnd VALUE === `, value);
    setStoreStartEndRadio(value);
  }, [setStoreStartEndRadio]);

  // const handleProjectsPicker = (value) => {
  //   setSelectedProjectData(value);
  //   console.log("value of project:::::::", value);
  // };

  const handleProjectsPicker = useCallback((value) => {
    setSelectedProjectData(value);
    //console.log("value of project:::::::", value);
  }, [setSelectedProjectData]);

  const handleCountryPicker = useCallback((value) =>{
    setselectedCountry(value);
    console.log("country :::::",value)
  },[setselectedCountry])

  /*
    useEffect(() => {
      if (storeSelectedPlanType === 'controller' && siteLocation === "/reports/main-report-dump") {
        const localStorageItems = JSON.parse(localStorage?.getItem("closedColumn"));
        if (!localStorageItems?.includes('Major Measure') && (storeSelectedPlanType === 'controller') && localStorageItems?.includes('Major Task')) {
          const ControllerBugetData = DuplicateContaineTeamManger?.filter(x => x.o_row_type !== 'MT');
          setTeamManagerData(ControllerBugetData);
        }
        else if (!localStorageItems?.includes('Major Task') && localStorageItems?.includes('Major Measure') && storeSelectedPlanType === 'controller') {
          const ControllerBugetData = DuplicateContaineTeamManger.filter(x => x.o_row_type !== 'MM');
          setTeamManagerData(ControllerBugetData);
        } else if (localStorageItems?.includes('Major Task') && localStorageItems?.includes('Major Measure') && storeSelectedPlanType === 'controller') {
          setTeamManagerData([]);
        }
        else if (!localStorageItems?.includes('Major Task') && !localStorageItems?.includes('Major Measure') && storeSelectedPlanType === 'controller') {
          setTeamManagerData(DuplicateContaineTeamManger);
        }
      }
    }, [siteLocation, teamManagerData, localStorage.getItem("closedColumn")]);
  
  
    useEffect(() => {
      if (storeSelectedPlanType === 'controller' && siteLocation === "/reports/team-managers") {
        const localStorageItems = JSON.parse(localStorage.getItem("closedColumn"));
        if ((storeSelectedPlanType === 'controller') && localStorageItems?.includes('Major Task')) {
          setTeamManagerData([]);
        }
        else {
          const ControllerBugetData = DuplicateContaineTeamManger?.filter(x => x.o_row_type !== 'MM');
          setTeamManagerData(ControllerBugetData);
        }
      }
    }, [teamManagerData, siteLocation, localStorage.getItem("closedColumn")]);
  */
  useEffect(() => {
    const localStorageItems = JSON.parse(localStorage.getItem("closedColumn"));
    if (storeSelectedPlanType === 'controller') {
      if ((siteLocation === "/reports/main-report-dump"  || siteLocation === "/reports/team-managers" )&& !resetFilter) {
        if (!localStorageItems?.includes('Major Measure') && localStorageItems?.includes('Major Task')) {
          const ControllerBugetData = DuplicateContaineTeamManger?.filter(x => x.o_row_type !== 'MT');
          setTeamManagerData(ControllerBugetData);
        } else if (!localStorageItems?.includes('Major Task') && localStorageItems?.includes('Major Measure')) {
          const ControllerBugetData = DuplicateContaineTeamManger.filter(x => x.o_row_type !== 'MM');
          setTeamManagerData(ControllerBugetData);
        } else if (localStorageItems?.includes('Major Task') && localStorageItems?.includes('Major Measure')) {
          setTeamManagerData([]);
        } else if (!localStorageItems?.includes('Major Task') && !localStorageItems?.includes('Major Measure')) {
          setTeamManagerData(DuplicateContaineTeamManger);
        }
       }/// else if (siteLocation === "/reports/team-managers" && !resetFilter) {
      //   if (localStorageItems?.includes('Major Task')) {
      //     setTeamManagerData([]);
      //   } else {
      //     const ControllerBugetData = DuplicateContaineTeamManger?.filter(x => x.o_row_type !== 'MM');
      //     setTeamManagerData(ControllerBugetData);
      //   }
      // }
    }
  }, [storeSelectedPlanType, siteLocation, teamManagerData, resetFilter, localStorage.getItem("closedColumn")]);


  const fetchTeamManagerReportData = async (page,limit) => {
    setTimesheetData([]);
    setTeamManagerData([]);
    // setTeamManagerData([]);
    setDuplicateContaineTeamManger([])
    // setDuplicateContaineTeamManger([])
    setManagerScreenLoading(true);
    setCurrentPage(page);
    setCurrentLimit(limit);
    let filterConditionsParam = [];
    // console.log("fetchTeamManagerReportData filterConditions :", filterConditions)
    // console.log("storeSelectedCheckerPickerValue :", storeSelectedCheckerPickerValue);
    if (storeSelectedCheckerPickerValue?.length > 0) {
      filterConditionsParam = storeSelectedCheckerPickerValue.map((item) => {
        if (item.teams) {
          return { ...filterConditionsParam, team: item.teams };
        } else if (item.teamManager) {
          return { ...filterConditionsParam, team_manager: item.teamManager };
        } else if (item.teamMembers) {
          return {
            ...filterConditionsParam,
            team_member_name: item.teamMembers,
          };
        } else if (item.process) {
          return { ...filterConditionsParam, process_name: item.process };
        } else if (item.majorMeasure) {
          return { ...filterConditionsParam, major_measure: item.majorMeasure };
        } else if (item.majorTask) {
          return { ...filterConditionsParam, major_task_name: item.majorTask };
        } else if (item.typeOfProblem) {
          return { ...filterConditionsParam, problem_type: item.typeOfProblem };
        } else if (item.task) {
          return { ...filterConditionsParam, task_name: item.task };
        } else if (item.taskDescription) {
          return {
            ...filterConditionsParam,
            task_description: item.taskDescription,
          };
        } else if (item.taskGroup) {
          return { ...filterConditionsParam, task_group: item.taskGroup };
        } else if (item.subTask) {
          return { ...filterConditionsParam, sub_task: item.subTask };
        } else if (item.subSubTask) {
          return { ...filterConditionsParam, sub_subtask: item.subSubTask };
        } else if (item.project) {
          return { ...filterConditionsParam, project: item.project };
        }else if (item.country) {
          return { ...filterConditionsParam, country: item.country };
        }
      });
      // console.log(
      //   "Final Team Manager Filter conditions --- ",
      //   filterConditionsParam
      // );
      setFilterConditions(filterConditionsParam);
      setStoreSelectedCheckerPickerValue(filterConditionsParam);
    }
    await axios
      .request({
        baseURL: `/api/v1/reports/team-manager-report`,
        params: {
          plantype: storeSelectedPlanType,
          reportby: storeSelectedReportBy,
          startdate: format(new Date(initStoreDateRange[0]), "yyyy-MM-dd"),
          enddate: format(new Date(initStoreDateRange[1]), "yyyy-MM-dd"),
          dollarshours: storeSelectedHoursDollarsRadio,
          detailsummary: storeSelectedDetailSummaryView,
          startend: storeStartEndRadio,
          columnfilters: JSON.stringify(filterConditionsParam) || "",
          columnorder: sortValue === "mm_sk, order_type, planned_budget_start_date desc"
            ? "planned_budget_start_date desc,mm_sk, order_type" :
            sortValue === "major_measure desc" && storeSelectedPlanType === "controller" ? "planned_budget_start_date desc, major_measure " :
              sortValue === "major_task_name desc" && storeSelectedPlanType === "controller" ? "planned_budget_start_date desc, major_task_name " :
                sortValue === "major_measure" && storeSelectedPlanType === "controller" ? "planned_budget_start_date , major_measure " :
                  sortValue === "major_task_name" && storeSelectedPlanType === "controller" ? "planned_budget_start_date , major_task_name "
                    : storeSelectedPlanType === "controller"
                      ? "mm_sk, order_type, planned_budget_start_date"
                      : sortValue,
          page: page,
          limit: limit,

        },
      })
      .then((resp) => {
        let gtr = resp.data.message.filter((x) => x.o_team === "Grand Total");
        let rows = resp.data.message.filter((x) => x.o_team !== "Grand Total");

        //console.log("MGR Grand Total Row Obj == ", gtr);
         setTeamManagerData(rows);
         setRowCount(resp.data.totalRowCount);
        // setTeamManagerData(prev=>[...prev, ...rows]);
        setDuplicateContaineTeamManger(rows)
        setStoreTeamMgrGrandTotalRow(gtr[0]);
        setManagerScreenLoading(false);
        setTotalTeamMangerScreen(resp.data.message.filter((x) => x.o_team === "Grand Total"))
      })
      .catch((error) => {
        console.error(
          "/api/v1/reports/team-manager-report api error === ",
          error
        );
      });
  };

  const fetchTimesheetData = async () => {
    setTimesheetData([]);
    setTimesheetData([]);
    setTeamManagerData([]);
    setManagerScreenLoading(true);
    let filterConditionsParam = [];
    //console.log("fetchTimesheetData filterConditions :", filterConditions);
    //console.log("storeSelectedCheckerPickerValue :",storeSelectedCheckerPickerValue);
    if (storeSelectedCheckerPickerValue?.length > 0) {
      filterConditionsParam = storeSelectedCheckerPickerValue.map((item) => {
        if (item?.teams) {
          return { ...filterConditionsParam, team_name: item.teams };
          // } else if (item?.teamManager) {
          //     return { ...filterConditions, team_manager: item.teamManager };
        } else if (item?.teamMembers) {
          return { ...filterConditionsParam, name: item.teamMembers }; // in timesheet you need to pass as name for team member filter
        } else if (item?.process) {
          return { ...filterConditionsParam, process_name: item.process };
        } else if (item?.majorMeasure) {
          return { ...filterConditionsParam, major_measure: item.majorMeasure };
        } else if (item?.majorTask) {
          return { ...filterConditionsParam, major_task_name: item.majorTask };
        } else if (item?.typeOfProblem) {
          return { ...filterConditionsParam, problem_type: item.typeOfProblem };
        } else if (item?.task) {
          return { ...filterConditionsParam, task_name: item.task };
        } else if (item?.taskDescription) {
          return {
            ...filterConditionsParam,
            task_description: item.taskDescription,
          };
        } else if (item?.taskGroup) {
          return { ...filterConditionsParam, task_group: item.taskGroup };
        } else if (item?.subTask) {
          return { ...filterConditionsParam, subtask: item.subTask };
        } else if (item?.subSubTask) {
          return { ...filterConditionsParam, subsub_task: item.subSubTask };
        }
      });
      //console.log("Final Timesheet Filter conditions --- ",filterConditionsParam);
      setFilterConditions(filterConditionsParam);
      setStoreSelectedCheckerPickerValue(filterConditionsParam);
    }

    await axios
      .request({
        baseURL: `/api/v1/crud/timesheet`,
        params: {
          memberid: currentUser.username,
          // plantype: storeSelectedPlanType,
          // reportby: storeSelectedReportBy,
          startdate: format(new Date(initStoreDateRange[0]), "yyyy-MM-dd"),
          enddate: format(new Date(initStoreDateRange[1]), "yyyy-MM-dd"),
          dollarshours: storeSelectedHoursDollarsRadio,
          detailsummary: storeSelectedDetailSummaryView,
          startend: storeStartEndRadio,
          columnfilters: JSON.stringify(filterConditionsParam) || "",
          columnorder: sortValue,
          page: 0,
          limit: 0,
        },
      })
      .then((resp) => {
        let gtr = resp.data.message.filter(
          (x) => x.o_major_measure === "Grand Total"
        );
        let rows = resp.data.message.filter(
          (x) => x.o_major_measure !== "Grand Total"
        );
        //console.log("TMSHT Grand Total Row Obj == ", gtr);
        setTimesheetData(rows);
        setStoreTimesheetGrandTotalRow(gtr[0]);
        setManagerScreenLoading(false);
        setTotalTimesheetScreen(resp.data.message.filter((x) => x.o_major_measure === "Grand Total"));
      })
      .catch((error) => {
        console.error("error while fetching fetchTeamManagerReportData", error);
      });
  };

  

  // project manageraoi call

  const fetchProjectManagerData = async () => {
    setTeamManagerData([]);
    setTeamManagerData([]);
    setStoreTeamMgrGrandTotalRow([])
    setDuplicateContaineTeamManger([])
    setManagerScreenLoading(true);
    let filterConditionsParam = [];
    // console.log("fetchTeamManagerReportData filterConditions :", filterConditions)
    // console.log("storeSelectedCheckerPickerValue :", storeSelectedCheckerPickerValue);
    if (storeSelectedCheckerPickerValue?.length > 0) {
      filterConditionsParam = storeSelectedCheckerPickerValue.map((item) => {
        if (item.teams) {
          return { ...filterConditionsParam, team: item.teams };
        } else if (item.teamManager) {
          return { ...filterConditionsParam, team_manager: item.teamManager };
        } else if (item.teamMembers) {
          return {
            ...filterConditionsParam,
            team_member_name: item.teamMembers,
          };
        } else if (item.process) {
          return { ...filterConditionsParam, process_name: item.process };
        } else if (item.majorMeasure) {
          return { ...filterConditionsParam, major_measure: item.majorMeasure };
        } else if (item.majorTask) {
          return { ...filterConditionsParam, major_task_name: item.majorTask };
        } else if (item.typeOfProblem) {
          return { ...filterConditionsParam, problem_type: item.typeOfProblem };
        } else if (item.task) {
          return { ...filterConditionsParam, task_name: item.task };
        } else if (item.taskDescription) {
          return {
            ...filterConditionsParam,
            task_description: item.taskDescription,
          };
        } else if (item.taskGroup) {
          return { ...filterConditionsParam, task_group: item.taskGroup };
        } else if (item.subTask) {
          return { ...filterConditionsParam, sub_task: item.subTask };
        } else if (item.subSubTask) {
          return { ...filterConditionsParam, sub_subtask: item.subSubTask };
        } else if (item.project) {
          return { ...filterConditionsParam, project: item.project };
        }else if (item.country) {
          return { ...filterConditionsParam, country: item.country };
        }
      });
      console.log(
        "Final Team Manager Filter conditions --- ",
        filterConditionsParam
      );
      setFilterConditions(filterConditionsParam);
      setStoreSelectedCheckerPickerValue(filterConditionsParam);
    }

    await axios
      .request({
        baseURL: `/api/v1/projectMgr/project-manager`,
        params: {
          plantype: storeSelectedPlanType,
          reportby: storeSelectedReportBy,
          startdate: format(new Date(initStoreDateRange[0]), "yyyy-MM-dd"),
          enddate: format(new Date(initStoreDateRange[1]), "yyyy-MM-dd"),
          dollarshours: storeSelectedHoursDollarsRadio,
          detailsummary: storeSelectedDetailSummaryView,
          startend: storeStartEndRadio,
          columnfilters: JSON.stringify(filterConditionsParam) || "",
          columnorder: '' ,
          page: 0,
          limit: 0,
          screenname: siteLocation === "/reports/timesheet" ? "Timesheet" : siteLocation === "/reports/team-managers" ? "Team Manager Screen" : "Main Report Dump",
        },
      })
      .then((resp) => {
        let gtr = resp.data.message.filter((x) => x.o_team === "Grand Total");
        let rows = resp.data.message.filter((x) => x.o_team !== "Grand Total");
        console.log("MGR Grand Total Row Obj == ", gtr);
        console.log("Testing for PM::::",tasksgroup.filter( (x) => x.label == parseInt(resp.data.message[0].o_task_group) )[0] || "" );
        
        setTeamManagerData(rows);
        setTasksDes(tasksgroup.filter((x) => x.id === parseInt(resp.data.message[0].task_group)));
        setDuplicateContaineTeamManger(rows)
        setStoreTeamMgrGrandTotalRow(gtr[0]);
        setManagerScreenLoading(false);
        setTotalTeamMangerScreen(resp.data.message.filter((x) => x.o_team === "Grand Total"))
      })
      .catch((error) => {
        console.error(
          "/api/v1/reports/project-manager api error === ",
          error
        );
      });
  };


  /** const fetchMasterTaskGroups = async () => {
     await axios
       .get("/api/v1/crud/task-groups")
       .then((resp) => {
         if (resp.data.success && resp.data.message.length)
           setStoreMasterTaskGroups(resp.data.message);
       })
       .catch((error) =>
         console.error(`Error From master task group API - `, error)
       );
   };*/

  // useEffect(() => {
  //     if (storeSelectedPlanType === 'controller') {
  //         setStoreSelectedHoursDollarsRadio("dollars");
  //         setStoreSelectedDetailSummaryView("summary");
  //         // setStoreSelectedReportBy('month')
  //     } else {
  //         setStoreSelectedHoursDollarsRadio("hours");
  //         setStoreSelectedDetailSummaryView("detail");
  //         // setStoreSelectedReportBy('day')
  //     }
  // }, [storeSelectedPlanType])

  useEffect(() => {
    setSiteLocation(window.location.pathname);
  }, [window.location.pathname]);

  /*
    useEffect(() => {
      setFilterConditions([]);
      setSortValue("");
      setStoreSelectedCheckerPickerValue([]);
      setSelectedTeams([]);
      setSelectedTeamMembers([]);
      setSelectedTeamManager([]);
      setSelectedTasks([]);
      setSelectedMajorMeasure([]);
      setSelectedProcessData([]);
      setSelectedTasksDes([]);
      setSelectedTasksGroup([]);
      setSelectedsubTasks([]);
      setSelectedSubSubTask([]);
      setSelectedPredecessor([]);
      setSelectedsuccessor([]);
      setSelectTypeOfProlem([]);
      setSelectedMajorTasks([]);
      setManagerScreenLoading(true);
  
      if (
        siteLocation === "/reports/team-managers" ||
        siteLocation === "/reports/main-report-dump"
      ) {
        axios
          .request({
            baseURL: `/api/v1/reports/team-manager-report`,
            params: {
              plantype: storeSelectedPlanType,
              reportby: storeSelectedReportBy,
              startdate: format(new Date(initStoreDateRange[0]), "yyyy-MM-dd"),
              enddate: format(new Date(initStoreDateRange[1]), "yyyy-MM-dd"),
              dollarshours: storeSelectedHoursDollarsRadio,
              detailsummary: storeSelectedDetailSummaryView,
              startend: storeStartEndRadio,
              columnfilters: "",
              columnorder:sortValue === "mm_sk, order_type, planned_budget_start_date desc"
              ? "planned_budget_start_date desc,mm_sk, order_type" :
              sortValue === "major_measure desc" && storeSelectedPlanType === "controller" ? "planned_budget_start_date desc, major_measure " :
                sortValue === "major_task_name desc" && storeSelectedPlanType === "controller" ? "planned_budget_start_date desc, major_task_name " :
                sortValue === "major_measure" && storeSelectedPlanType === "controller" ? "planned_budget_start_date , major_measure " :
                sortValue === "major_task_name"  && storeSelectedPlanType === "controller" ? "planned_budget_start_date, major_task_name "
                  : storeSelectedPlanType === "controller"
                    ? "mm_sk, order_type, planned_budget_start_date"
                    : sortValue,
              page: 0,
              limit: 0,
            },
          })
          .then((resp) => {
            let gtr = resp.data.message.filter((x) => x.o_team === "Grand Total");
            let rows = resp.data.message.filter(
              (x) => x.o_team !== "Grand Total"
            );
            console.log("MGR Grand Total Row Obj == ", gtr);
            setTeamManagerData(rows);
            setDuplicateContaineTeamManger(rows)
            setStoreTeamMgrGrandTotalRow(gtr[0]);
            setManagerScreenLoading(false);
          })
          .catch((error) => {
            console.error(
              "/api/v1/reports/team-manager-report api error === ",
              error
            );
          });
      }
  
      if (siteLocation === "/reports/timesheet") {
        axios
          .request({
            baseURL: `/api/v1/crud/timesheet`,
            params: {
              memberid: currentUser.username,
              // plantype: storeSelectedPlanType,
              // reportby: storeSelectedReportBy,
              startdate: format(new Date(initStoreDateRange[0]), "yyyy-MM-dd"),
              enddate: format(new Date(initStoreDateRange[1]), "yyyy-MM-dd"),
              dollarshours: storeSelectedHoursDollarsRadio,
              detailsummary: storeSelectedDetailSummaryView,
              startend: storeStartEndRadio,
              columnfilters: "",
              columnorder: "",
              page: 0,
              limit: 0,
            },
          })
          .then((resp) => {
            let gtr = resp.data.message.filter(
              (x) => x.o_major_measure === "Grand Total"
            );
            let rows = resp.data.message.filter(
              (x) => x.o_major_measure !== "Grand Total"
            );
            console.log("TMSHT Grand Total Row Obj == ", gtr);
            setTimesheetData(rows);
            setStoreTimesheetGrandTotalRow(gtr[0]);
            setManagerScreenLoading(false);
          })
          .catch((error) => {
            console.error("/api/v1/reports/timesheet api error === ", error);
          });
      }
    }, [resetFilter]);
  */

  useEffect(() => {
    if (storeSelectedPlanType === "controller") {
      let toastShown = false;
      const checkConditions = async () => {
        const hasMajorTaskName = filterConditions.some((obj) =>
          obj?.hasOwnProperty("major_task_name")
        );
        const hasMajorMajorName = filterConditions.some((obj) =>
          obj?.hasOwnProperty("major_measure")
        );
        if (((hasMajorTaskName && filterConditions.length <= 2 && hasMajorMajorName) || (hasMajorMajorName && filterConditions.length == 1) || (hasMajorTaskName && filterConditions.length == 1))) {
          setManagerScreenLoading(true);
          toastShown = true;
        }
        else if (
          filterConditions.length > 0 &&
          storeSelectedCheckerPickerValue?.length > 0 &&
          !toastShown
        ) {
          toaster.push(ErrorMessage, { placement, duration: 3000 });
          setManagerScreenLoading(true);
          toastShown = true;
        }
      };
      checkConditions();
    }
  }, [filterConditions, storeSelectedPlanType]);

  const fetchDataProductTimelines24month = async () => {
		setProductTimelines24Months([]);
		try {
			let { data } = await axios.get(`/api/v1/timelines/24-months`)
			setProductTimelines24Months(data.message);
		} catch (error) {
			console.error('Error While Fetching 24 Months DATA  === ', error);
		}
	};
  const WeeklyfetchData = async () => {
    setweeklydata([]);
		try {
			let { data } = await axios.get(`/api/v1/timelines/weekly`)
			setweeklydata(data.message);
		} catch (error) {
			console.error('Error While Fetching 24 Months DATA  === ', error);
		}
	};

  useEffect ( () =>{
    if (siteLocation === "/timelines/24-months"){
      fetchDataProductTimelines24month();
    }
    if (siteLocation === "/timelines/weekly"){
      WeeklyfetchData();
    }

  },[siteLocation]) 
  


  return (
    <StoreContext.Provider
      value={{
        initStoreDateRange,
        setInitStoreDateRange,
        storeSelectedPlanType,
        setStoreSelectedPlantype,
        storeSelectedReportBy,
        setStoreSelectedReportBy,
        storeSelectedHoursDollarsRadio,
        setStoreSelectedHoursDollarsRadio,
        storeSelectedDetailSummaryView,
        setStoreSelectedDetailSummaryView,
        storeStartEndRadio,
        setStoreStartEndRadio,
        teamManagerData,
        setTeamManagerData,
        storeMasterTaskGroups,
        setStoreMasterTaskGroups,
        closedColumnList,
        setClosedColumnList,
        handleStoreHoursDollarsRadioChange,
        handleStoreSummaryDetailRadioView,
        handleStoreStartEndRadioChange,
        loading,
        setLoading,
        filterValue,
        setFilterValue,
        sortValue,
        setSortValue,
        showColumn,
        setShowColumn,
        pageSize,
        setPageSize,
        siteLocation,
        setSiteLocation,
        fetchTeamManagerReportData,
        fetchTimesheetData,
        storeSelectedCheckerPickerValue,
        setStoreSelectedCheckerPickerValue,
        resetFilter,
        SetResetFilter,
        managerScreenLoading,
        setManagerScreenLoading,
        timesheetData,
        setTimesheetData,
        majorTasks,
        setMajorTasks,
        storeMajorMeasureGroups,
        setStoreMajorMeasureGroups,
        majorMeasure,
        setMajorMeasure,
        processData,
        setProcessData,
        teams,
        setTeams,
        teamMembers,
        setTeamMembers,
        teamManager,
        setTeamManager,
        tasks,
        setTasks,
        tasksDesc,
        setTasksDes,
        tasksgroup,
        setTasksGroup,
        inputVisible,
        setInputVisible,
        inputValue,
        setInputValue,
        selectedTeams,
        setSelectedTeams,
        selectedTeamMembers,
        setSelectedTeamMembers,
        selectedTeamManager,
        setSelectedTeamManager,
        selectedTasks,
        setSelectedTasks,
        selectedMajorTasks,
        setSelectedMajorTasks,
        selectedMajorMeasure,
        setSelectedMajorMeasure,
        selectedProcessData,
        setSelectedProcessData,
        selectedTasksDesc,
        setSelectedTasksDes,
        selectedTasksgroup,
        setSelectedTasksGroup,
        selectedSubTasks,
        setSelectedsubTasks,
        selectedSubSubTasks,
        setSelectedSubSubTask,
        SelectedPredecessor,
        setSelectedPredecessor,
        Selectedsuccessor,
        setSelectedsuccessor,
        SelectTypeOfProlem,
        setSelectTypeOfProlem,
        handleTeamPicker,
        handleTeamManagerPicker,
        handleTeamMemberPicker,
        handleProcessPicker,
        handleMajorMeasurePicker,
        handleMajorTaskPicker,
        handleTaskPicker,
        handleTaskDescPicker,
        handleSubTaskPicker,
        handleSubSUbTaskPicker,
        handleTaskGroupPicker,
        handlePredecessorPicker,
        handlSuccessorPicker,
        handleTypeOfProblemPicker,
        selectedFilterValues,
        setFilterConditions,
        filterConditions,
        subtaskDescrption,
        subSubtaskDescrption,
        managers,
        setManagers,
        admins,
        setAdmins,
        approvers,
        setApprovers,
        storeMajorMeasureProjectEntry: storeProjects,
        setStoreMajorMeasureProjectEntry: setStoreProjects,
        selectedProjectsData,
        setSelectedProjectData,
        handleProjectsPicker,
        storeTeamMgrGrandTotalRow,
        setStoreTeamMgrGrandTotalRow,
        storeTimesheetGrandTotalRow,
        setStoreTimesheetGrandTotalRow,
        refresh,
        setRefresh,
        rolesList,
        setRolesList,
        teamsList,
        setTeamsList,
        listCustomReport,
        getCustomeReportList,
        reportlabel,
        setreportlabel,
        setListCustomReport,
        spName, 
        setspdetail,
        totalTeamMangerScreen,
        totalTimesheetScreen,
         ProductTimelines24Months, setProductTimelines24Months,
        weeklydata, setweeklydata,fetchProjectManagerData, getMajorTasks,getMajorMeasure 
        ,selectedCountry, setselectedCountry,handleCountryPicker,country
        ,ControllermajorTasks,ControllermmajorMeasure,
        rowCount,currentPage,currentLimit
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  return useContext(StoreContext);
};
